import { HeaderText } from "@/components/ui";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { useUser } from "@/network/useUser";
import { Practitioner } from "@curai/js-fhir-tools";
import { useState } from "react";
import { sortLiveQueuePatients } from "./LiveQueue.util";
import { LiveQueueTable } from "./LiveQueueTable";
import { useWaitingRoomDashboardDashboard } from "./network/useWaitingRoomDashboard";
import { LIVE_QUEUE_FREEZE_FLAG, useFrozenQueue } from "./useFrozenQueue";

export const LiveQueue = () => {
  const { data: user } = useUser();
  const [mineOnly, setMineOnly] = useState(false);
  const [abridged, setAbridged] = useState(false);

  const {
    data: waitingRoomData,
    isLoading,
    isError,
  } = useWaitingRoomDashboardDashboard({ mineOnly, abridged });

  const practitioner = new Practitioner(user?.professional.fhir || {});

  // One flag gates the whole freeze + animation experience. Default off until
  // ConfigCat resolves (only an explicit `true` enables it).
  const { data: freezeFlag } = useConfigCatFeatureFlag(LIVE_QUEUE_FREEZE_FLAG);
  const freezeEnabled = freezeFlag === true;

  // Freeze the rendered list while the clinician is interacting with it so a
  // realtime update can't shift a row out from under their cursor. Ordering is
  // unchanged — we sort the (possibly frozen) list exactly as before.
  const {
    patients,
    addedCount,
    removedCount,
    isFrozen,
    flush,
    freezeHandlers,
  } = useFrozenQueue(waitingRoomData?.patients, freezeEnabled);

  const messages = sortLiveQueuePatients({
    patients,
    practitioner,
  });

  return (
    <div className="p-6 h-full overflow-auto pb-12">
      <HeaderText size="xl" className="mb-4">
        Waiting Room
      </HeaderText>

      <section className="mt-4">
        <LiveQueueTable
          myQueue={messages?.myQueue}
          otherCliniciansQueue={messages?.otherCliniciansQueue}
          isLoading={isLoading}
          isError={isError}
          practitioner={practitioner}
          mineOnly={mineOnly}
          onMineOnlyChange={setMineOnly}
          abridged={abridged}
          onAbridgedChange={setAbridged}
          addedCount={addedCount}
          removedCount={removedCount}
          isFrozen={isFrozen}
          onFlush={flush}
          freezeHandlers={freezeHandlers}
          animationsEnabled={freezeEnabled}
        />
      </section>
    </div>
  );
};
